// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"f3d46b30","200":"f39d0cc3","287":"5c471214","290":"601382c3","453":"4c9d30bb","550":"7ae2e3b1","608":"96e4aad0","841":"ce05030e"}[chunkId] + ".chunk.js";
};